module.exports = __webpack_public_path__ + "img/baie.6b52fd94.png";